import { z } from 'zod';

export const noteContentSchema = z.object({
  content: z.string().max(200, 'Note must be less than 200 characters'),
});

export type NoteContentFormData = z.infer<typeof noteContentSchema>;
